export const CATEGORIES = [
  {
    id: 'floor',
    family: 'SMARTBOT',
    name: 'Floor Cleaning Robots',
    tagline: 'Vacuum · Mop · AI Navigation · Self-Empty Dock',
    path: '/floor-cleaning-robots',
    image: 'https://customer-assets.emergentagent.com/job_80fffe0f-7ad4-44ce-aa36-08a4bccc4edb/artifacts/4ik16avb_PHOTO-2026-05-30-18-18-13.jpg',
    gradient: 'from-sky-50 via-white to-blue-100/50',
  },
  {
    id: 'pool',
    family: 'POOLBOT',
    name: 'Pool Cleaning Robots',
    tagline: 'Commercial & Residential · Wall Climbing · Deep Cleaning',
    path: '/pool-cleaning-robots',
    image: 'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/y34dz1wb_PHOTO-2025-12-24-16-57-25.jpg',
    gradient: 'from-cyan-50 via-white to-teal-100/50',
  },
  {
    id: 'window',
    family: 'SHINEBOT',
    name: 'Window Cleaning Robots',
    tagline: 'Frameless & Framed Glass · AI Safety · High Suction',
    path: '/window-cleaning-robots',
    image: 'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/6j2kav5l_Window%20robo.jpeg',
    gradient: 'from-slate-50 via-white to-zinc-100/70',
  },
  {
    id: 'lawn',
    family: 'LAWNBOT',
    name: 'Lawn Mowing Robots',
    tagline: 'RTK Navigation · AI Vision · Automatic Lawn Care',
    path: '/robotic-lawn-mowers',
    image: 'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/h221a4vl_4885c0df-e93f-4fc7-b5f9-c51e42ee3ac0-md.jpeg',
    gradient: 'from-emerald-50 via-white to-green-100/50',
  },
];
